// extracted by mini-css-extract-plugin
export var divider = "_pk-0";
export var systemMessage = "_pk-1";